import { Action } from "@ngrx/store";
import {
  updateGoalPayload,
  filterGoalsObj,
  updateGoalInactivePayload,
  updateMissingSchoolGoalsPayload,
} from "./state";

export const GET_GOALS = "GET_GOALS";
export const GET_GOALS_SUCCESS = "GET_GOALS_SUCCESS";
export const GET_GOALS_ERROR = "GET_GOALS_ERROR";

export const UPDATE_GOAL = "UPDATE_GOAL";
export const UPDATE_GOAL_INACTIVE = "UPDATE_GOAL_INACTIVE";
export const UPDATE_FILTER_GOAL_VALUE = "UPDATE_FILTER_GOAL_VALUE";
export const APPLY_FILTER_GOAL = "APPLY_FILTER_GOAL";
export const UPDATE_FILTER_GOAL_INACTIVE = "UPDATE_FILTER_GOAL_INACTIVE";
export const UPDATE_MISSING_SCHOOL_GOALS = "UPDATE_MISSING_SCHOOL_GOALS";
export const SAVE_GOALS = "SAVE_GOALS";
export const SAVE_GOALS_SUCCESS = "SAVE_GOALS_SUCCESS";
export const SAVE_GOALS_ERROR = "SAVE_GOALS_ERROR";

export class GetGoalsAction implements Action {
  readonly type = GET_GOALS;

  constructor(public payload: string) {}
}

export class UpdateGoalAction implements Action {
  readonly type = UPDATE_GOAL;

  constructor(public payload: updateGoalPayload) {}
}

export class UpdateFilterGoalValueAction implements Action {
  readonly type = UPDATE_FILTER_GOAL_VALUE;

  constructor(public payload: number) {}
}

export class ApplyFilterGoalAction implements Action {
  readonly type = APPLY_FILTER_GOAL;

  constructor(public payload: filterGoalsObj) {}
}

export class UpdateGoalInactiveAction implements Action {
  readonly type = UPDATE_GOAL_INACTIVE;
  constructor(public payload: updateGoalInactivePayload) {}
}

export class UpdateFilterGoalInactiveAction implements Action {
  readonly type = UPDATE_FILTER_GOAL_INACTIVE;
  constructor(public payload: updateGoalInactivePayload) {}
}

export class updateMissingSchoolGoalsAction implements Action {
  readonly type = UPDATE_MISSING_SCHOOL_GOALS;
  constructor(public payload: updateMissingSchoolGoalsPayload) {}
}

export class saveGoalsAction implements Action {
  readonly type = SAVE_GOALS;
  constructor(public payload: string) {}
}

export type Actions =
  | GetGoalsAction
  | UpdateGoalAction
  | UpdateFilterGoalValueAction
  | ApplyFilterGoalAction
  | UpdateGoalInactiveAction
  | UpdateFilterGoalInactiveAction
  | updateMissingSchoolGoalsAction
  | saveGoalsAction;
